import React from "react";
import Preloader from "../helper/Preloader";
import HeaderTwo from "../components/HeaderTwo";
import Breadcrumb from "../components/Breadcrumb";
import ShopSection from "../components/ShopSection";
import ShippingTwo from "../components/ShippingTwo";
import FooterOne from "../components/FooterOne";
import ColorInit from "../helper/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import HeaderOne from "../components/HeaderOne";
import { useParams } from "react-router-dom";
import Subcategorysection from "../components/Subcategorysection";
import Brandsectiondata from "../components/Brandsectiondata";
import Varientdatadisplay from "../components/Varientdatadisplay";
import Productlistdata from "../components/Productlistdata";

const Shoppagesix = () => {  
  const { id } = useParams();

  return (
    <>
      {/* ColorInit */}
      <ColorInit color={true} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#FA6400" />

      {/* Preloader */}
      <Preloader />

      {/* HeaderOne */}
      <HeaderOne category={true} />

      {/* Breadcrumb */}
      <Breadcrumb title={"Products"} />

      {/* ShopSection */}
      
      {<Productlistdata id={id} />}

      

      {/* ShippingTwo */}
      <ShippingTwo />

      {/* FooterTwo */}
      <FooterOne />


    </>
  );
};

export default Shoppagesix;
